import init from '../../helpers/init';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  let $modal = $('.js-load-modal-tickets-question');
  if ($modal.length) {
    let $btnY = $modal.find('.js-btn-yes-tickets-question');
    let $btnN = $modal.find('.js-btn-no-tickets-question');
    let skip = false;

    $('a[href*="/tikets/?CODE="]').on('click', (e: JQuery.ClickEvent) => {
      return;

      if (skip) {
        skip = false;
        return;
      }

      let url = e.currentTarget.getAttribute('href');
      let uri = new BX.Uri(url);
      let ticketCode = uri.getQueryParam('CODE');

      if (BX.getCookie('ticketQuestion' + ticketCode)) {
        return;
      }

      e.preventDefault();

      [$btnY, $btnN].forEach(($btn) => {
        $btn[0].onclick = () => {
          BX.ajax.get('/local/ajax/public/Tickets/setTicketsQuestionAnswer/', {
            ticketCode: ticketCode,
            answer: $btn === $btnY ? 'Y' : 'N',
          }, (response: any) => {
            let result = JSON.parse(response);
            if (!BX.Type.isObject(result)) {
              console.error('Unknown response');
            } else if (!result.success && result.errors) {
              console.error(result.errors);
            }

            skip = true;
            e.currentTarget.click();
          });
        };
      });

      BX.showWait();
      BX.ajax.get('/local/ajax/public/Tickets/isNeedTicketsQuestion/', {
        ticketCode: ticketCode,
      }, (response: any) => {
        BX.closeWait();
        let result = JSON.parse(response);
        if (!BX.Type.isObject(result)) {
          console.error('Unknown response');
        } else {
          if (result && result.success) {
            if (result.data && result.data.showPopup) {
              $modal.modal('show');
              return;
            }
          } else if (result.errors) {
            console.error(result.errors);
          }
        }

        skip = true;
        e.currentTarget.click();
      });

    });
  }
});
